var Constants = require('../constants/Constants');
var BaseStore = require('./BaseStore');

var violations;

var ClientServiceEmailStore = new BaseStore({
    defaultData: []
});

ClientServiceEmailStore.violations = function () {
    return violations;
};

ClientServiceEmailStore.getEmailsForService = function (serviceId) {
    if (!this._data.hasOwnProperty(serviceId)) {
        return [];
    }

    return this._data[serviceId];
};

ClientServiceEmailStore.register(Constants.api.GET_SERVICES, function (payload) {
    var action = payload.action;

    if (action.state === Constants.request.PENDING) {
        this._loading = true;

        return true;
    }

    if (action.state === Constants.request.FINISHED) {
        this._loading = false;

        var emails = {};
        action.response.body.services.forEach(function (service, i) {
            if (!service.hosted_mail) {
                return;
            }

            emails[service.id] = service.hosted_mail.addresses;
        });
        this.setData(emails);

        return true;
    }
});

ClientServiceEmailStore.register(Constants.api.SERVICE_EMAIL_CREATE, function (payload) {
    var action = payload.action;

    if (action.state === Constants.request.PENDING) {
        this._loading = true;
        violations = null;

        return true;
    }

    if (action.state === Constants.request.ERROR) {
        this._loading = false;
        violations = action.response.body.violations;

        return true;
    }

    if (action.state === Constants.request.FINISHED) {
        this._loading = false;

        var service = action.params.service;
        this._data[service.id].push(action.params.email_address);

        return true;
    }
});

ClientServiceEmailStore.register(Constants.api.SERVICE_EMAIL_PASSWORD, function (payload) {
    var action = payload.action;

    if (action.state === Constants.request.PENDING) {
        this._loading = true;

        return true;
    }

    if (action.state === Constants.request.ERROR) {
        this._loading = false;

        return true;
    }

    if (action.state === Constants.request.FINISHED) {
        this._loading = false;

        return true;
    }
});

ClientServiceEmailStore.register(Constants.api.DELETE_SERVICE_EMAIL, function (payload) {
    var action = payload.action;

    if (action.state === Constants.request.PENDING) {
        this._loading = true;
        violations = null;

        return true;
    }

    if (action.state === Constants.request.ERROR) {
        this._loading = false;
        violations = action.response.body.violations;

        return true;
    }

    if (action.state === Constants.request.FINISHED) {
        this._loading = false;

        var service = action.params.service;
        var pos = this._data[service.id].indexOf(action.params.email_address);
        if (pos > -1) {
            this._data[service.id].splice(pos, 1);
        }

        return true;
    }
});

module.exports = ClientServiceEmailStore;



// WEBPACK FOOTER //
// ./app/stores/ClientServiceEmailStore.js